import { Button, Intent } from "@blueprintjs/core";
import saveAs from "file-saver";
import { showError, FieldSet, FlexFieldGroup, FGSelectInput } from "nsitools-react";
import * as React from "react";
import { PersonApi, FileDownload, DysplasiaApi } from "../../api";
import { FGSRSHDateMaskInput, SmallFormGenerator } from "../../components";
import { useTl, useApiService } from "../../hooks";
import { ETLCodes } from "../../locales";
import { b64toBlob } from "../../utils";
import styled from "styled-components";
import { useReferential } from "../../hooks/useReferential";

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 0.75rem;
`;

export interface IHDReportProps {}

export const HDReport: React.FunctionComponent<IHDReportProps> = (props) => {
  const { t } = useTl();
  const api = useApiService(DysplasiaApi);
  const [breeds, bloading] = useReferential((a) => a.getBreeds(null), true, []);
  const [saving, setsaving] = React.useState(false);
  const getDoc = React.useCallback(
    async (data) => {
      try {
        setsaving(true);
        var file = await api.getDysplasiaReport(data);
        if (file?.fileBytes) {
          var blob = b64toBlob(new FileDownload({ base64Content: file.fileBytes, fileName: file.fileName }));
          saveAs(blob, file.fileName);
        }
        setsaving(false);
      } catch {
        showError(t(ETLCodes.Error));
        setsaving(false);
      }
    },
    [api, t]
  );

  return (
    <FieldSet title={t(ETLCodes.HDReport)}>
      <SmallFormGenerator
        initialValues={{}}
        onSubmit={getDoc}
        editMode={true}
        showDeleteButton={false}
        hideButtons={true}
      >
        <FlexFieldGroup>
          <FGSRSHDateMaskInput name="dateFrom" label={t(ETLCodes.DateFrom)} />
          <FGSRSHDateMaskInput name="dateTo" label={t(ETLCodes.DateTo)} />
          <FGSelectInput name="breedId" label={t(ETLCodes.Breed)} items={breeds} loading={bloading} />
        </FlexFieldGroup>

        <Container>
          <Button
            type={"submit"}
            text={t(ETLCodes.GenerateReport)}
            loading={saving}
            intent={Intent.PRIMARY}
            icon={<i className="far fa-file-excel" />}
          />
        </Container>
      </SmallFormGenerator>
    </FieldSet>
  );
};
